import { InputSkeleton, Skeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading({ isModal = false }: { isModal?: boolean }) {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} isModal={isModal} />

      <Container>
        <LeftSection forceFullWidth={isModal}>
          <CardContainer bodyClassName="flex items-start gap-6 sm:items-end">
            <section>
              <Skeleton className="h-24 w-[7.84rem] rounded-xl" />
            </section>
            <FormLayout className="mt-0 flex-1 gap-y-4 sm:pb-6">
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />
            <PhoneNumberLoading />
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />
            <PhoneNumberLoading />
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
